export default function initHeaderTooltip() {
    document.querySelectorAll('.header-tooltip-new').forEach($headerTooltip => {
        if ($headerTooltip) {
            let cookie = getCookie('SHOW_LOGIN_TOOLTIP');
            if (!cookie) {
                $headerTooltip.classList.remove('hidden');
                setTimeout(() => {
                    $headerTooltip.classList.add('hidden');
                    setCookie('SHOW_LOGIN_TOOLTIP', 'false', 365);
                }, '5000');
            }
        }
    });
    document.querySelectorAll('.header-tooltip-logged-in-new').forEach($headerLoggedInTooltip => {
        if ($headerLoggedInTooltip) {
            let cookie = getCookie('SHOW_LOGGED_IN_TOOLTIP');
            if (!cookie) {
                $headerLoggedInTooltip.classList.remove('hidden');
                setTimeout(() => {
                    $headerLoggedInTooltip.classList.add('hidden');
                    setCookie('SHOW_LOGGED_IN_TOOLTIP', 'false', 365);
                }, '10000');
            }
        }
    });
    document.querySelectorAll('.login-close-link').forEach($closeLink => {
        $closeLink.addEventListener('click', () => {
            let $headerLoggedInTooltip = document.querySelector('.header-tooltip-logged-in-new');
            if ($headerLoggedInTooltip !== null && $headerLoggedInTooltip !== undefined) {
                $headerLoggedInTooltip.classList.add('hidden');
                setCookie('SHOW_LOGGED_IN_TOOLTIP', 'false', 365);
            }
        });
    });
}

/**
 * @param {String} cname
 * @param {String} cvalue
 * @param {Number} exdays
 */
function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

/**
 * @param {String} cname
 * @returns String
 */
function getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.includes(name)) {
            return c;
        }
    }
    return '';
}
